import { assetUrl } from '@/utils/assetUrls';
import type { ResolvedAssets, UploadedAsset, MediaAsset, TextAsset } from '@/types/api/assets';
import type { DownloadableAsset } from '@/types/downloadable';

export function toDownloadableToolResult(result: MediaAsset | TextAsset): DownloadableAsset {
  if (result.type === 'text') {
    return {
      type: 'text',
      blob: new Blob([result.value], { type: 'text/plain;charset=utf-8' }),
      extension: 'txt',
    };
  }
  return { type: result.type, url: result.url, blobstore: result.blobstore, mime: result.mime };
}

export function isPreviewableOutput(result: UploadedAsset): result is Exclude<UploadedAsset, { type: 'rendering' }> {
  if (result.type === 'text') {
    // Text outputs store their content inline; an empty string is still valid content.
    return typeof result.value === 'string';
  }

  return result.type === 'image' || result.type === 'video' || result.type === 'audio' || result.type === '3D';
}

export function isDownloadableToolResult(
  result: UploadedAsset,
  resolvedAssets: ResolvedAssets,
): result is Exclude<UploadedAsset, { type: 'rendering' }> {
  return isPreviewableOutput(result) && (result.type === 'text' || Boolean(assetUrl(result, resolvedAssets)));
}
